import React from "react";
import Modal from "react-native-modal";
import ResponsiveContent from "../shared/responsive-content";
import { View, Pressable, Text } from "react-native";
import CloseIcon from "@/assets/svgs/close-icon";
import { Button } from "../ui/button";

function ConfirmLogoutModal({
  isVisible,
  onClose,
  onConfirm,
}: {
  isVisible: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  return (
    <Modal
      animationIn="slideInUp"
      animationOut="slideOutDown"
      isVisible={isVisible}
      onBackdropPress={onClose}
      onDismiss={onClose}
      useNativeDriver
      useNativeDriverForBackdrop
      hideModalContentWhileAnimating
    >
      <ResponsiveContent>
        <View className="mx-4 bg-teachLoop-creamBase rounded-xl px-8 pt-4 pb-8">
          <View className="items-end">
            <Pressable
              onPress={onClose}
              className="active:opacity-80"
              style={{ marginHorizontal: -12 }}
            >
              <CloseIcon
                pathClassName="stroke-teachLoop-textPrimary"
                className="size-6"
              />
            </Pressable>
          </View>
          <View className="gap-8">
            <Text className="font-zilla-slab-medium font-medium text-[28px] leading-[1.2] text-black">
              Are you sure want to logout?
            </Text>

            <Text className="text-base font-geologica-regular font-normal leading-[1.5] text-teachLoop-textPrimary">
              You can always sign back in to your account.
            </Text>

            <View className="gap-4">
              <Button fullWidth size="md" intent="primary" onPress={onConfirm}>
                <Button.Text size="md">Yes, logout</Button.Text>
              </Button>

              <Button fullWidth size="md" outline onPress={onClose}>
                <Button.Text size="md" intent="primary">Keep me signed in</Button.Text>
              </Button>
            </View>
          </View>
          <View className="h-3" />
        </View>
      </ResponsiveContent>
    </Modal>
  );
}

export default ConfirmLogoutModal;
